<template>
  <v-container>
    <v-layout
      class="mt-1"
      row
      wrap
      v-if="company"
    >
      <v-flex
        xs12
        sm12
        lg10
        offset-lg1
        xl6
        offset-xl3
        class
      >
        <v-card>
          <v-toolbar
            dense
            card
            
          >
            <listing-save
              :company="company"
              :id="company.id"
              isBigbutton
              isFlatbutton
            ></listing-save>
            <!-- <nachricht-erstellen v-if="company.user_id" :betriebID="company.id"></nachricht-erstellen>  -->
            <v-spacer></v-spacer>
            <!-- <span v-if="company.email">
              <kontakt-betrieb :company="company"></kontakt-betrieb>
            </span> -->
          </v-toolbar>
          <v-card-title
            primary-title
            class="lighten-4"
          >
            <h1 class="mb-0 ml-3" :class="ÜberschriftSize">{{ company.vollername }}</h1>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container
              grid-list-xl
              my-0
              pa-0
            >
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm5
                  offset-sm4
                  md4
                  offset-md1
                  v-if="company"
                >
                  <div v-if="company.innungen">
                    <div v-if="company.innungen.length > 0">
                      <v-layout wrap>
                        <v-flex
                          xs12
                          v-for="innung in company.innungen"
                          :key="innung.id"
                        >
                          <v-card flat  :to="{ name: 'Innung', params: { slug: innung.slug }}">
                            <div v-if="innung.logo">
                              <v-img
                                :src="'/' + innung.logo"
                                contain
                                height="120px"
                              ></v-img>
                            </div>
                            <v-card-text class="text-xs-center">
                              <span class="subheading">
                                <strong>Fachbetrieb</strong>
                                <br>
                                {{ innung.name }}
                              </span>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </div>
                    <div v-else>
                      <v-layout wrap v-if="company.innung">
                        <v-flex xs12>
                          <v-card flat>
                            <div v-if="company.innung.logo">
                              <v-img
                                :src="'/' + company.innung.logo"
                                contain
                                height="120px"
                              ></v-img>
                            </div>
                            <v-card-text class="text-xs-center">
                              <span class="subheading">
                                <strong>Fachbetrieb</strong>
                                <br>
                                {{ company.innung.name }}
                              </span>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md6
                  offset-xs0
                  offset-md1
                >
                  <v-card flat>
                    <v-container align-center>
                      <v-flex>
                        <KHLogo :khstadt="KHStadt"></KHLogo>
                      </v-flex>
                    </v-container>
                  </v-card>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md6
                  offset-md0
                >
                  <v-card flat>
                    <v-card-text :class="DatenPadding">
                      <v-list two-line>
                        <v-divider></v-divider>
                        <div v-if="company.telefon">
                          <v-list-tile
                            v-bind:href="'tel:' + company.telefon_link"
                            v-if="!company.versteckt"
                          >
                            <v-list-tile-content>
                              <v-list-tile-title>{{ company.telefon }}</v-list-tile-title>
                              <v-list-tile-sub-title>Telefon</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon>phone</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider></v-divider>
                        </div>
                        <div v-if="company.fax">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title v-if="!company.versteckt">{{ company.fax }}</v-list-tile-title>
                              <v-list-tile-sub-title>Fax</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon>print</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>     
                        <v-divider></v-divider>
                        </div>
                        <div v-if="company.email">                    
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title v-if="!company.versteckt">
                                <a :href="`mailto:${company.email}`">{{ company.email }}</a>
                              </v-list-tile-title>
                              <v-list-tile-sub-title>E-Mail</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon>alternate_email</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider></v-divider>                    
                        </div>         
                        <div v-if="company.name != company.offiziellername">                    
                          <v-list-tile v-if="company.offiziellername">
                            <v-list-tile-content>
                              <v-list-tile-title v-if="!company.versteckt">
                                {{ company.offiziellername }}
                              </v-list-tile-title>
                              <v-list-tile-sub-title>Name laut Handwerksrolle</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon>badge</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider v-if="company.offiziellername"></v-divider>                    
                        </div>                             
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md6
                >
                  <v-card flat>
                    <v-card-text :class="DatenPadding">
                      <v-list two-line>
                       <v-divider></v-divider>
                         <v-list-tile >
                          <v-list-tile-content>
                            <v-list-tile-title v-if="!company.versteckt">
                             {{ company.address }}
                             </v-list-tile-title>
                            <v-list-tile-sub-title>Adresse</v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-icon>location_on</v-icon>
                          </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title >{{ StadtBreakpoint }}</v-list-tile-title>
                              <v-list-tile-sub-title>Stadt</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon>location_city</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>   
                          <v-divider></v-divider>  
                           <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title >{{ company.plz }}</v-list-tile-title>
                              <v-list-tile-sub-title>Postleitzahl</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon>drafts</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>   
                          <v-divider></v-divider>  
                        <div v-if="company.website">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                <a
                                  :href="`${company.website}`"
                                  target="_blank"
                                  rel="nofollow"
                                >{{ WebseiteOhneHttp }}</a> 
                              </v-list-tile-title>
                              <v-list-tile-sub-title>Webseite</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon>web</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider></v-divider>
                        </div>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container
              fluid
              grid-list-lg
              px-0
            >
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                  md4
                  v-for="cert in company.zertifikate"
                  :key="cert.name"
                >
                  <v-card
                    flat
                    class="pa-3"
                  >
                    <v-img
                      :src="'/' + cert.logo"
                      v-if="cert.logo"
                      contain
                      max-height="80"
                    ></v-img>
                    <v-card-text class="text-xs-center subheading">
                      {{ cert.name }}
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <h3 class="title font-weight-regular mb-2 ml-4">Verknüpfte Leistungen</h3>
                <v-layout row wrap class="pl-4">
                  <div
                    v-for="leistung in company.leistungen"
                    :key="leistung.id"
                    class="text-truncate"
                  >
                   <v-btn 
                    flat 
                    
                    class="grey lighten-2 subheading text-none ma-1 py-4"
                    style="border-radius: 2px;"
                    text-color="grey darken-4" 
                    :to="{ name: 'gewerkdetail', params: { id: leistung.gewerk.slug }}">
                      <v-icon left color="grey lighten-5">label</v-icon> <h4 class="subheading">{{ leistung.leistung }}</h4>
                  </v-btn>
                  </div>
                </v-layout>

                <!-- <h3 class="title font-weight-regular mb-2 ml-4 mt-4">Innung<span v-if="Innungkombi.length > 1">en</span></h3>
                <v-layout row wrap class="pl-4">
                   
                  <div
                    v-for="innung in Innungkombi"
                    :key="innung.id"
                    class="subheading py-2 px-3 mx-1 my-1 grey lighten-2"
                    text-color="grey darken-4"
                    style="border-radius: 2px;"
                  >
                   <router-link :to="{ name: 'Innung', params: { slug: innung.slug }}">
                   <v-avatar size="60" tile class="mr-3">
                    <v-img
                      v-if="innung.logo"
                      :src="innung.logo"
                      max-height="100px"
                      contain
                    ></v-img>
                  </v-avatar>{{ innung.name }}
                   </router-link>
                  </div>
                </v-layout> -->
                <!-- <v-layout>
                  <v-flex>{{ company  }}</v-flex>
                </v-layout> -->
              <v-layout
                align-center
                justify-space-between
                row wrap
                class="px-0 mx-2  mt-2"
              >
                <div
                  v-if="company.updated_at"
                  class="pl-4"
                >
                <span v-if="company.updated_at"> 
                  Aktualisiert 
                  <timeago :datetime="company.updated_at"></timeago>
                </span>
                </div>
                <div>
                  <fehler-melden :id="company.id"></fehler-melden>
                </div>
              </v-layout>

            </v-container>
          </v-card-text>
        </v-card>
        <div v-if="company.stellen">
         <stellen :company="company" v-if="company.stellen.length > 0"></stellen>
        </div>
      </v-flex>
    </v-layout>
<!-- 
    
{{ company.updated_at }}
     
     {{ metaCanonUrl }} -->


  </v-container>
  
</template>


<script>
// import { mapGetters } from 'vuex'

import ListingSave from '~/components/ListingSave.vue'
import FehlerMelden from '~/components/FehlerMelden.vue'
// import KontaktBetrieb from '~/components/companies/KontaktBetrieb.vue'

// import NachrichtErstellen from '~/components/nachrichten/NachrichtErstellen.vue'
import KHLogo from '~/components/companies/khlogo.vue'
import InnungCard from '~/components/companies/InnungCardBetriebsProfil.vue'
import Stellen from '~/components/companies/stellen.vue'

export default {
  props: ['company'],
  components: {
    ListingSave,
    FehlerMelden,
    KHLogo,
    InnungCard,
    Stellen,
    //KontaktBetrieb
  },

  data () {
    return {
      betriebcheckloading: true
    }
  },
  metaInfo () {
    return {
      meta: [
              { name: 'description', content: this.metaDescriptionText }
      ],
      link: [
              { rel: 'canonical', href: this.metaCanonUrl }
      ]
    }
  },
  computed: {
    KHStadt: function () {
      var stadt
      if (this.company) {
        if (this.company.innungen) {
          if (this.company.innungen.length > 0) {
            stadt = this.company.innungen[0].stadt
          } else {
            if (this.company.innung) {
              stadt = this.company.innung.stadt
            }
          }
        } else {
          if (this.company.innung) {
            if (this.company.innung.stadt) {
              stadt = this.company.innung.stadt
            }
          }
        }
      }
      return stadt
    },
    ÜberschriftSize: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'headline'
      } else {
        return 'display-1'
      }
    },
    DatenPadding: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'px-0'
      } else {
        return 'px-4'
      }
    },
    Innungkombi: function () {
      const superinnung = {}
      if (this.company.innung) {
        if (this.company.innungen) {
          const superinnnug = [].concat(
            this.company.innung,
            this.company.innungen
          )
          return superinnnug
        } else {
          return this.company.innung
        }
      } else if (this.company.innungen) {
        const superinnung = this.company.innungen
        return superinnung
      }
      return superinnung
    },
    AdresseBreakpoint: function () {
      if (this.company) {
        if (this.$vuetify.breakpoint.name === 'xs') {
          return this.company.address
        } else {
          var stadtteilnullfix = this.company.stadtteil || ' '
          return this.company.address + ' in ' + this.company.stadt + ' ' + stadtteilnullfix
        }
      }
    },
    StadtBreakpoint: function () {
      if (this.company) {
        var stadtteilnullfix = this.company.stadtteil || ' '
        return this.company.stadt + ' ' + stadtteilnullfix
      }
    },
    WebseiteOhneHttp: function () {
      if (this.company) {
        if (this.company.website) {
          return this.company.website.replace(/^https?\:\/\//i, '')
        }
      }
    },
    angezeigteInnung: function () {
      var name
      if (this.company) {
        if (this.company.innungen) {
          if (this.company.innungen.length > 0) {
            name = this.company.innungen[0].name
          } else {
            if (this.company.innung) {
              name = this.company.innung.name
            }
          }
        } else {
          if (this.company.innung) {
            if (this.company.innung.name) {
              name = this.company.innung.name
            }
          }
        }
      }
      return name
    },
    metaDescriptionText: function () {
      if (this.company) {
        var stadtteilnullfix = this.company.stadtteil || ' '
        return this.company.vollername + ', Fachbetrieb der ' + this.angezeigteInnung + ' der Kreishandwerkerschaft ' + this.KHStadt + ' in ' + this.company.stadt + ' ' + stadtteilnullfix
      }
    },
    metaCanonUrl: function () {
      if (this.company) {
        return 'https://www.lokaleshandwerk.de/betrieb/' + this.company.slug
      }
    }

  },
  mounted: function () {
    this.setRendered()
  },
  methods: {
    setRendered: function () {
      window.IS_RENDERED = true
    }
  }
}
</script>

<style>
</style>